var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("design-dialog", {
    attrs: {
      visible: _vm.visible,
      width: 1100,
      wrapClassName: "dialog-goods-source-manager",
      title: _vm.$t("com.alreadyGoodsData"),
      confirmLoading: _vm.loading,
      footer: null
    },
    on: {
      isOk: _vm.handleConfirm,
      isCancel: _vm.handleCancel
    }
  }, [_c("div", {
    staticClass: "container-body"
  }, [_c("div", {
    staticClass: "table-container",
    staticStyle: {
      height: "70vh",
      "overflow-y": "scroll"
    }
  }, [_c("a-table", {
    staticClass: "components-table-demo-nested",
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      rowKey: "productSpecificationId",
      columns: _vm.columns,
      "data-source": _vm.goods_list,
      pagination: false
    },
    on: {
      "hook:mounted": _vm.handleTableMounted
    },
    scopedSlots: _vm._u([{
      key: "productNameScopedSlots",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(text) + " "), _c("br"), _vm._v(" " + _vm._s(record.productSpecification || "") + " ")]);
      }
    }, {
      key: "productOnlinedateScopedSlots",
      fn: function fn(text, record) {
        return _c("span", {}, [text ? [_vm._v(" " + _vm._s(text) + " ")] : [_vm._v(" -- ")]], 2);
      }
    }, {
      key: "productStatus",
      fn: function fn(text, record) {
        return _c("span", {}, [record.productStatus === 1 ? [_c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("com.put")) + " ")])] : [_c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("com.out")) + " ")])]], 2);
      }
    }, {
      key: "operation",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a", {
          on: {
            click: function click($event) {
              return _vm.handleDeleteGoods(record);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("com.delete")) + " ")])]);
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "productNoSlots"
    },
    slot: "productNoSlots"
  }, [_vm._v(" " + _vm._s(_vm.$t("com.productNo")) + " "), _c("br")]), _c("span", {
    attrs: {
      slot: "sellPriceSlots"
    },
    slot: "sellPriceSlots"
  }, [_vm._v(" " + _vm._s(_vm.$t("com.sellPrice")) + _vm._s(_vm.$t("com.taxIncluded")) + " ")])])], 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };